import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../../api';
import DashboardLayout from '../../../Components/Dashboard/DashboardLayout';
import './AdminSuite.css';

const AdminCreateServicePage = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    title: '',
    short_description: '',
    details: '',
    published: true,
    sort_order: 0,
  });

  const set = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

  const submit = async e => {
    e.preventDefault();
    if (!form.title.trim()) { toast.error('Title is required'); return; }
    if (!form.details.trim()) { toast.error('Details is required'); return; }

    try {
      setSaving(true);
      await api.post('/services', {
        ...form,
        sort_order: Number(form.sort_order) || 0,
        published: Boolean(form.published),
      });
      toast.success('Service created');
      navigate('/admin/services');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to create service');
    } finally {
      setSaving(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="container py-4 admin-suite">
        <div className="admin-suite-header">
          <div>
            <h3 className="admin-suite-title">Add Service</h3>
            <p className="admin-suite-subtitle">Create a new footer service entry.</p>
          </div>
          <button className="btn btn-outline-secondary" onClick={() => navigate('/admin/services')}>
            &larr; Back
          </button>
        </div>

        <form onSubmit={submit}>
          <div className="card admin-card border-0 shadow-sm mb-3">
            <div className="card-body p-4">
              <h5 className="admin-section-title">Service Details</h5>
              <div className="row g-3">
                <div className="col-md-8">
                  <label className="form-label fw-semibold">Title <span className="text-danger">*</span></label>
                  <input
                    className="form-control"
                    required
                    placeholder="e.g. Financial Advisory"
                    value={form.title}
                    onChange={e => set('title', e.target.value)}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label fw-semibold">Sort Order</label>
                  <input
                    className="form-control"
                    type="number"
                    min="0"
                    placeholder="0"
                    value={form.sort_order}
                    onChange={e => set('sort_order', e.target.value)}
                  />
                  <div className="form-text">Lower numbers appear first.</div>
                </div>
                <div className="col-12">
                  <label className="form-label fw-semibold">Short Description</label>
                  <input
                    className="form-control"
                    maxLength={500}
                    placeholder="One-line summary shown in footer (max 500 chars)"
                    value={form.short_description}
                    onChange={e => set('short_description', e.target.value)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label fw-semibold">Details <span className="text-danger">*</span></label>
                  <textarea
                    className="form-control"
                    rows={6}
                    required
                    placeholder="Full description shown in the modal when clicking the service link."
                    value={form.details}
                    onChange={e => set('details', e.target.value)}
                  />
                </div>
                <div className="col-12">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="published"
                      checked={form.published}
                      onChange={e => set('published', e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="published">
                      Published (visible in footer)
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex gap-2">
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Creating…' : 'Create Service'}
            </button>
            <button type="button" className="btn btn-outline-secondary" onClick={() => navigate('/admin/services')}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default AdminCreateServicePage;
